import type { MonedaConversor } from "./Conversor"

/**
 * Lo que devuelve `GET /api/v1/tasas/vigentes`.
 *
 * ⚠ **Hay DOS números y no son intercambiables.** `tasa` es la convención del ledger
 * —unidades por 1 USD— y `bs_por_unidad` es la lectura natural —bolívares por una
 * unidad—, que es la única con la que se convierte a mano. La traducción entre las
 * dos la hace el servidor (`panel_tasas.vigentes_en_bolivares`) y no se repite aquí.
 */
export type TasaVigente = {
  codigo: string
  nombre: string
  simbolo: string
  es_referencia: boolean
  tasa: string | null
  bs_por_unidad: string | null
  fuente: string | null
  fecha_valor: string | null
}

const BOLIVAR = "BS"
const DOLAR = "USD"

/**
 * Las monedas que puede enseñar el conversor, en el orden en que se leen aquí: el
 * bolívar primero —es el eje—, después el dólar, y el resto detrás.
 *
 * ⚠ **Una divisa sin tasa registrada se queda fuera.** Enseñar su campo vacío
 * invitaría a teclear un importe que no se puede convertir, y el usuario no tiene
 * forma de saber por qué no pasa nada.
 */
export function monedasDeTasas(tasas: readonly TasaVigente[]): MonedaConversor[] {
  const peso = (codigo: string) => (codigo === BOLIVAR ? 0 : codigo === DOLAR ? 1 : 2)
  return tasas
    .filter((t) => t.bs_por_unidad !== null)
    .sort((a, b) => peso(a.codigo) - peso(b.codigo) || a.codigo.localeCompare(b.codigo))
    .map((t) => ({ codigo: t.codigo, bsPorUnidad: t.bs_por_unidad }))
}
